<template>
  <div>
    <!-- <Header /> -->

    <div class="flex">
      <SideBar />

      <div
        class="w-[90%] mx-auto lg:w-full lg:mr-10 mt-10 rounded-3xl heightfix bg-gradient-to-br from-white via-white to-blue-50/30 shadow-2xl"
      >
        <!-- new design -->

        <!-- desktop -->
        <div class="hidden lg:block h-full">
          <div class="flex flex-col lg:flex-row h-full">
            <!-- left side start -->
            <div
              class="flex flex-col gap-6 lg:w-[50%] 2xl:w-[25%] rounded-3xl h-full"
              style="box-shadow: 0px 2px 30px 0px #01b0f926"
            >
              <div
                class="py-5 bg-[#0085DB] flex justify-between gap-3 items-center px-10 rounded-t-3xl hidden"
              >
                <p class="text-white text-lg text-center font-bold">
                  Add Group
                </p>
                <img
                  src="@/assets/basil_add-outline.svg"
                  alt=""
                  class="w-7 h-7 cursor-pointer"
                  @click="groupcreate()"
                />
              </div>
              <!-- group list start -->
              <div v-if="grouplist" class="overflow-y-scroll">
                <div class="pt-6 pb-2">
                  <p class="text-primary text-lg text-center font-bold">
                    Group
                  </p>
                </div>
                <div class="relative max-w-64 mx-auto">
                  <form @submit.prevent="searchUserValue">
                    <input
                      type="text"
                      placeholder="Search"
                      id="search"
                      v-model="search_title"
                      @input="searchUserValue"
                      class="w-full pl-4 pr-10 py-2 border border-gray-300 rounded-full bg-[#F0F5F9] text-gray-500 focus:outline-none focus:ring-2 focus:ring-gray-300"
                    />
                    <button type="submit" class="">
                      <div
                        class="absolute right-3 top-2.5 h-5 w-5 text-gray-400"
                      >
                        <img src="@/assets/search_icon1.svg" alt="" srcset="" />
                      </div>
                    </button>
                  </form>
                </div>

                <div class="mt-5">
                  <div
                    v-if="totalgrouplist.length > 0"
                    class="overflow-y-auto lg:h-[calc(100vh-350px)]"
                  >
                    <div
                      v-for="group in this.totalgrouplist"
                      :key="group"
                      class=""
                    >
                      <div
                        v-if="group.id"
                        @click="setActiveGroup(group)"
                        class="flex items-center border-b py-3 gap-1 justify-center px-10 mb-0 cursor-pointer hover:bg-gray-200"
                        :class="[
                          'cursor-pointer',
                          activeStudentUUID === group.id
                            ? 'bg-gray-200'
                            : 'bg-white',
                        ]"
                      >
                        <div class="w-[11%]">
                          <p
                            class="border-1 rounded-full w-7 h-7 border-gray-300 flex items-center justify-center text-white font-bold mx-auto"
                            :style="{
                              backgroundColor: getDynamicColor(group.title),
                            }"
                          >
                            {{ group.title.charAt(0).toUpperCase() }}
                          </p>
                        </div>

                        <p
                          class="text-base lg:text-[16px] text-[#333333] w-full px-2"
                        >
                          <span class="capitalize">{{
                            group.title || "NA"
                          }}</span>
                        </p>
                      </div>
                    </div>
                  </div>
                  <div v-else class="flex justify-center">No Group</div>
                </div>
              </div>

              <!-- group list end -->

              <!-- group create start -->
              <div v-if="groupnewcreate" class="p-5 flex flex-col gap-6">
                <div class="">
                  <img
                    src="@/assets/leftarrow.svg"
                    alt=""
                    srcset=""
                    class="cursor-pointer"
                    @click="
                      this.groupnewcreate = false;
                      this.grouplist = true;
                    "
                  />
                </div>
                <form
                  action=""
                  @submit.prevent="groupform"
                  class="flex flex-col gap-6"
                >
                  <div>
                    <input
                      type="text"
                      v-model="grouptitle"
                      name=""
                      id=""
                      class="border-b border-gray-400 w-full p-3 outline-none"
                      placeholder="Group Name"
                    />
                  </div>

                  <div>
                    <textarea
                      name=""
                      id=""
                      v-model="description"
                      cols="30"
                      rows="5"
                      placeholder="Group Description "
                      class="border border-gray-400 w-full p-3 outline-none bg-[#F6F6F6]"
                    ></textarea>
                  </div>

                  <div class="flex justify-center">
                    <button
                      class="bg-blues text-white text-lg py-2 px-10 rounded-3xl"
                    >
                      Create Group
                    </button>
                  </div>

                  <div
                    v-if="createmessages"
                    class="flex justify-center text-sm text-green-400 font-bold"
                  >
                    {{ createmessages }}
                  </div>
                </form>
              </div>
            </div>
            <!-- left side end -->
                <div
              v-if="defaultimg"
              class="bg-white h-full rounded-3xl border w-full text-center lg:w-[70%] 2xl:w-[75%] flex flex-col justify-center overflow-y-auto"
            >
              <!-- Custom SVG -->
              <div class="flex justify-center mb-6">
                <img
                  src="@/assets/chat/default_img.png"
                  class=""
                  alt=""
                  srcset=""
                />
              </div>
              <!-- Title -->
              <h2 class="text-xl font-semibold text-gray-800">
                Group Chat
                <span class="text-sm text-gray-500 align-top"></span>
              </h2>
              <!-- Description -->
              <p class="text-gray-600 text-sm mt-2">
                Chat privately with any user in real-time.
                <br />
                Share images, documents, videos
              </p>
              <!-- Footer -->
              <p class="text-xs text-gray-400 mt-4">
                All messages are secured with end-to-end encryption.
              </p>
            </div>
            <!-- Right side start -->
            <div
              v-if="selectedgroup"
              class="bg-[#F0F5F9] h-full w-full overflow-hidden lg:w-[75%] rounded-3xl relative"
              :style="{
                backgroundImage: `url(${require('@/assets/chat/new_bg.png')})`,
              }"
              :class="
                isFullScreenContact ? 'w-full' : ' lg:w-[70%] 2xl:w-[75%]'
              "
            >
              <div
                :class="[
                  'transition-all duration-300 relative h-full',
                  showContactInfo && !isFullScreenContact
                    ? 'w-full  md:w-[calc(100%-350px)]'
                    : 'w-full ',
                ]"
                :style="{
                  backgroundImage: `url(${require('@/assets/chat/new_bg.png')})`,
                }"
              >
                <div
                  class="flex flex-col h-full bg-black/10 rounded-3xl relative"
                >
                  <div
                    class="absolute w-full left-0 right-0 cursor-pointer"
                    @click="showContactInfo = true;  this.groupstudentlist(selectedgroup.id);"
                  >
                    <div
                      class="bg-[#FFFFFF] rounded-2xl m-4 py-2 px-3 flex justify-center gap-2 items-center"
                    >
                      <div class="">
                        <p
                          class="border-1 rounded-full w-7 h-7 border-gray-300 flex items-center justify-center text-white font-bold mx-auto"
                          :style="{
                            backgroundColor: getDynamicColor(
                              this.selectedgroup.title
                            ),
                          }"
                        >
                          {{ this.selectedgroup.title.charAt(0).toUpperCase() }}
                        </p>
                      </div>
                      <p class="text-center text-primary font-semibold">
                        {{ this.selectedgroup.title || "NA" }}
                      </p>
                    </div>
                  </div>

                  <div class="h-full w-full px-3 pt-14 pb-16">
                    <div class="p-4 h-full overflow-y-auto" id="chatContainer">
                      <div
                        v-for="(message, index) in totalmessage"
                        :key="index"
                        class="my-4 flex flex-col gap-1"
                      >
                        <template v-if="shouldShowDateLabel(index)">
                          <div
                            class="text-center font-semibold text-gray-200 text-xs"
                          >
                            <button
                              class="bg-blue-300 text-white py-1 px-2 rounded-md"
                            >
                              {{ formatDateLabel(message.created_at) }}
                            </button>
                          </div>
                        </template>
                        <div
                          v-if="message.member_email"
                          class="flex"
                          :class="[
                            'my-4 flex gap-2 w-full',
                            message.member_email === this.studentdata.email
                              ? 'justify-end'
                              : 'justify-start',
                          ]"
                        >
                          <div class="flex gap-2 max-w-[350px]">
                            <div>
                              <div
                                v-if="message.member_profile_image"
                                class="w-8 h-10"
                              >
                                <img
                                  :src="message.member_profile_image"
                                  alt=""
                                  srcset=""
                                  class="rounded-full w-7 h-7 mx-auto"
                                />
                              </div>
                              <img
                                v-else
                                src="@/assets/newd/image.png"
                                alt=""
                                srcset=""
                                class="w-7 h-7 object-contain"
                              />
                            </div>
                            <div
                              class="flex flex-col gap-2 max-w-[275px]"
                              :class="[
                                !message.message && message.file_name
                                  ? message.member_email ===
                                    this.studentdata.email
                                    ? 'bg-[#E8F6FF] px-2 py-2 rounded-xl text-gray-900'
                                    : 'bg-gray-200 px-2 py-2 rounded-xl text-gray-900'
                                  : message.member_email ===
                                   this.studentdata.email
                                  ? 'bg-[#E8F6FF] text-gray-900 rounded-xl px-4 py-2 shadow-md break-words rounded-br-sm' // Text (or text + file) from self
                                  : 'bg-gray-200 text-gray-900 rounded-xl px-4 py-2 shadow-md break-words rounded-bl-sm', // Text (or text + file) from others
                              ]"
                            >
                              <div class="flex justify-between items-center">
                                <h1
                                  class="text-sm font-bold text-[#0085DB] mr-5"
                                >
                                  <span v-if="message.member_display_name">
                                    {{ message.member_display_name }}
                                  </span>
                                  <span v-else>Na</span>
                                </h1>
                                <p class="text-xs text-gray-500">
                                  {{ formatDateTime(message.created_at) }}
                                </p>
                              </div>

                              <div class="text-xs text-wrap w-full relative">
                                <div
                                  v-if="message.file_name"
                                  class="relative group w-fit"
                                >
                                  <div
                                    class="relative inline-block w-fit mt-2 group"
                                  >
                                    <!-- 🖼️ Image Preview -->
                                    <img
                                      v-if="
                                        /\.(jpe?g|png|gif|webp|bmp)$/i.test(
                                          message.file_name
                                        )
                                      "
                                      :src="message.file_name"
                                      class="rounded w-[235px] shadow cursor-pointer"
                                      alt="Image"
                                    />

                                    <!-- 📽️ Video Preview -->

                                    <video
                                      v-else-if="
                                        /\.(mp4|webm|ogg)$/i.test(
                                          message.file_name
                                        )
                                      "
                                      :src="message.file_name"
                                      controls
                                      class="rounded w-60 shadow"
                                    ></video>

                                    <div
                                      v-else
                                      class="p-2 rounded w-60 break-words text-sm text-blue-700 underline"
                                    >
                                      📄
                                      {{
                                        message.filename ||
                                        getFileName(message.file_name)
                                      }}
                                    </div>

                                    <button
                                      @click="toggleDropdown(index)"
                                      class="absolute top-1 right-1 p-1 rounded-full text-white bg-black/50 2xl:bg-transparent 2xl:text-[#4f3f3fc3] 2xl:hidden 2xl:group-hover:block"
                                      title="Options"
                                    >
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        class="w-4 h-4"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        stroke="currentColor"
                                      >
                                        <path
                                          stroke-linecap="round"
                                          stroke-linejoin="round"
                                          stroke-width="2"
                                          d="M19 9l-7 7-7-7"
                                        />
                                      </svg>
                                    </button>

                                    <div
                                      v-if="dropdownIndex === index"
                                      class="absolute top-8 right-1 bg-white border rounded shadow text-xs z-50"
                                    >
                                      <button
                                        @click="downloadFile(message)"
                                        class="px-4 py-2 hover:bg-gray-100 w-full text-left"
                                      >
                                        ⬇️ Download
                                      </button>
                                    </div>
                                  </div>
                                </div>

                                <div>
                                  <span v-if="message.message">{{
                                    message.message
                                  }}</span>
                                  <!-- <span v-else>Na</span> -->
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                       <!-- Dummy loading preview when loading a file -->
                      <div
                        v-if="sendingFileUrl"
                        class="my-4 flex gap-2 w-full justify-end"
                      >
                        <div
                          class="flex flex-col items-center justify-center p-4 rounded-lg bg-black/40 shadow-xl w-[230px] h-[100px]"
                        >
                          <img
                            src="@/assets/loading.gif"
                            alt="loading"
                            class="w-6 h-6 object-contain"
                          />
                          <p class="mt-2 text-white font-medium text-xs">
                            Loading…
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="absolute bottom-2 w-full left-0 right-0">
                    <div
                      class="bg-[#FFFFFF] rounded-2xl m-4 flex items-center justify-between py-2 px-3 gap-3"
                    >
                      <!-- Plus Button -->

                      <div class="relative">
                        <div
                          v-if="showIcons"
                            @click.stop
                          class="absolute bottom-12 left-0 flex flex-col items-center gap-3 transition-all duration-300 z-10"
                        >
                          <!-- Document Icon -->
                          <div class="relative group">
                            <button
                              @click="triggerInput('document')"
                              class="w-8 h-8 bg-blue-500 text-white rounded-full flex items-center justify-center shadow hover:bg-blue-600"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                class="w-4 h-4"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  d="M7 2h8l5 5v13a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2z"
                                />
                                <path d="M14 2v6h6" />
                              </svg>
                            </button>
                            <span
                              class="absolute left-full top-1/2 ml-2 -translate-y-1/2 bg-gray-800 text-white text-xs px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition"
                            >
                              Document
                            </span>
                          </div>

                          <!-- Image Icon -->
                          <div class="relative group">
                            <button
                              @click="triggerInput('image')"
                              class="w-8 h-8 bg-blue-500 text-white rounded-full flex items-center justify-center shadow hover:bg-blue-600"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                class="w-4 h-4"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                viewBox="0 0 24 24"
                              >
                                <rect
                                  x="3"
                                  y="3"
                                  width="18"
                                  height="18"
                                  rx="2"
                                />
                                <circle cx="8" cy="8" r="1.5" />
                                <path d="M21 15l-5-5L5 21" />
                              </svg>
                            </button>
                            <span
                              class="absolute left-full top-1/2 ml-2 -translate-y-1/2 bg-gray-800 text-white text-xs px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition"
                            >
                              Image
                            </span>
                          </div>

                          <!-- Video Icon -->
                          <div class="relative group">
                            <button
                              @click="triggerInput('video')"
                              class="w-8 h-8 bg-blue-500 text-white rounded-full flex items-center justify-center shadow hover:bg-blue-600"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                class="w-4 h-4"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                viewBox="0 0 24 24"
                              >
                                <rect
                                  x="3"
                                  y="5"
                                  width="15"
                                  height="14"
                                  rx="2"
                                />
                                <path d="M21 7l-5 4v2l5 4V7z" />
                              </svg>
                            </button>
                            <span
                              class="absolute left-full top-1/2 ml-2 -translate-y-1/2 bg-gray-800 text-white text-xs px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition"
                            >
                              Video
                            </span>
                          </div>

                          <input
                            ref="document"
                            type="file"
                            accept=".pdf,.doc,.docx"
                            class="hidden"
                            @change="handleFile('document', $event)"
                          />
                          <input
                            ref="image"
                            type="file"
                            accept="image/*"
                            class="hidden"
                            @change="handleFile('image', $event)"
                          />
                          <input
                            ref="video"
                            type="file"
                            accept="video/*"
                            class="hidden"
                            @change="handleFile('video', $event)"
                          />
                        </div>

                        <!-- Plus Button -->
                        <button
                          @click.stop="toggleIcons"
                          class="w-8 h-8 text-white rounded-full flex items-center justify-center hover:bg-[#E8F6FF]"
                          title="Add"
                        >
                          <div v-if="!showIcons">
                            <img src="@/assets/chat/plus.svg" alt="" />
                          </div>
                          <div
                            v-else
                            class="text-[#34A9F1] bg-[#E8F6FF] rounded-full p-1"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              class="h-6 w-6"
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                            >
                              <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="M6 18L18 6M6 6l12 12"
                              />
                            </svg>
                          </div>
                        </button>
                      </div>

                      <!-- Input + Preview -->
                      <div class="flex flex-col w-full gap-2">
                        <!-- File Preview -->
                        <div
                          v-if="fileData.name"
                          class="w-full px-4 py-2 bg-gray-100 rounded-xl relative mb-1"
                        >
                          <div class="flex justify-between items-start">
                            <div>
                              <p class="text-xs font-semibold mb-1">Preview:</p>

                              <template v-if="fileData.type === 'image'">
                                <img
                                  :src="fileData.url"
                                  alt="Preview"
                                  class="w-40 rounded shadow"
                                />
                              </template>
                              <template v-else-if="fileData.type === 'video'">
                                <video
                                  :src="fileData.url"
                                  controls
                                  class="w-60 rounded shadow"
                                />
                              </template>
                              <template v-else>
                                <p class="text-xs text-gray-700">
                                  {{ fileData.name }}
                                </p>
                              </template>
                            </div>
                            <button
                              @click="clearPreview"
                              class="text-red-500 hover:text-red-700 text-sm"
                            >
                              ✕
                            </button>
                          </div>
                        </div>

                        <!-- Text Input -->
                        <input
                          v-model="messageVal"
                          @keyup.enter="newsendmsg(this.selectedgroup)"
                          type="text"
                          class="w-full border-none outline-none text-sm bg-transparent text-gray-800"
                          placeholder="Type your text here..."
                        />
                      </div>
                      <button
                        @click="newsendmsg(this.selectedgroup)"
                        class="w-[40px] h-[40px] rounded-full flex items-center justify-center"
                      >
                        <img src="@/assets/chat/right.svg" alt="" />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
               <transition name="slide">
                <div
                  v-if="showContactInfo"
                  class="absolute top-0 right-0 h-full w-full bg-[#f0f0f0]  text-white rounded-l-3xl z-40 shadow-lg"
                  :class="
                    isFullScreenContact ? 'w-full' : 'w-full 2xl:w-[350px]'
                  "
                   :style="{
                  backgroundImage: `url(${require('@/assets/chat/Whats.jpeg')})`,
                }"
                >
                  <div
                    class="flex justify-between items-center p-4 border-b border-white/10"
                  >
                    <h2 class="text-lg font-semibold">Contact Info</h2>
                    <button
                      @click="showContactInfo = false"
                      class="text-white text-2xl"
                    >
                      &times;
                    </button>
                  </div>

                  <div class="">
                    <div class="p-4 text-center mb-4">
                      <img
                        v-if="selectedgroup.member_profile_image"
                        :src="selectedgroup.member_profile_image"
                        class="w-20 h-20 object-cover rounded-full mx-auto"
                        alt="Profile"
                      />
                      <img
                        v-else
                        src="@/assets/newd/image.png"
                        class="w-20 h-20 object-cover rounded-full mx-auto"
                        alt="Default"
                      />
                      <h3 class="mt-2 font-semibold text-lg">
                        {{ selectedgroup.title }}
                      </h3>
                      <p class="text-sm text-gray-400">
                        Hey there! I am using Group chat.
                      </p>
                    </div>

                    <!-- Media/docs preview -->
                    <div class="hidden">
                      <h4 class="font-semibold text-sm text-gray-400 mb-2">
                        Media, Docs
                      </h4>
                      <div class="grid grid-cols-3 gap-2">
                        <div
                          v-for="n in 3"
                          :key="n"
                          class="w-full h-20 bg-white/10 rounded"
                        ></div>
                      </div>
                    </div>
                    <div class="px-4 py-2 text-gray-300 flex items-center">{{studentgrouplist.length}} Members only </div>
                    <div
                      class="w-full max-w-md mx-auto  text-white rounded-lg shadow-lg overflow-hidden"
                    >
                      <div
                        class="divide-y divide-[#2a3942] h-[calc(100vh-467px)] overflow-y-auto py-2 rounded-b-3xl"
                      >
                        <div
                          v-for="(student, index) in studentgrouplist"
                          :key="index"
                          class="flex items-center gap-3 px-4 py-3 hover:bg-[#202c33] cursor-pointer"
                        >
                          <div
                            class="w-9 h-9 rounded-full flex items-center justify-center text-white font-bold"
                          >
                            <div v-if="student.profile_image">
                              <img
                                :src="student.profile_image"
                                alt=""
                                class="w-9 h-9 rounded-full border-2 border-white"
                              />
                            </div>
                            <div v-else>
                              <img
                                src="@/assets/new/image.png"
                                alt=""
                                class="w-9 h-9 rounded-full border-2 border-white"
                              />
                            </div>
                          </div>
                          <div class="flex-1">
                            <div class="font-medium text-sm">
                              {{ student.display_name }}
                            </div>
                            <!-- <div class="text-sm text-gray-400 line-clamp-1">
                              {{ student.status }}
                            </div> -->
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </transition>
            </div>
            <!-- Right side end -->
          </div>
        </div>


        <!-- mobile -->
        <div class="block lg:hidden h-full">
          <div class="flex flex-col lg:flex-row h-full">
            <!-- left side start -->
            <div
              v-if="studentmessage"
              class="flex flex-col gap-6 lg:w-[50%] 2xl:w-[25%] rounded-3xl h-full"
              style="box-shadow: 0px 2px 30px 0px #01b0f926"
            >
              <div
                class="py-5 bg-[#0085DB] flex justify-between gap-3 items-center px-10 rounded-t-3xl hidden"
              >
                <p class="text-white text-lg text-center font-bold">
                  Add Group
                </p>
                <img
                  src="@/assets/basil_add-outline.svg"
                  alt=""
                  class="w-7 h-7 cursor-pointer"
                  @click="groupcreate()"
                />
              </div>
              <!-- group list start -->
              <div v-if="grouplist" class="">
                <div class="pt-6 pb-2">
                  <p class="text-primary text-lg text-center font-bold">
                    Group
                  </p>
                </div>
                <div class="relative max-w-64 mx-auto">
                  <form @submit.prevent="searchUserValue">
                    <input
                      type="text"
                      placeholder="Search"
                      id="search"
                      v-model="search_title"
                      @input="searchUserValue"
                      class="w-full pl-4 pr-10 py-2 border border-gray-300 rounded-full bg-[#F0F5F9] text-gray-500 focus:outline-none focus:ring-2 focus:ring-gray-300"
                    />
                    <button type="submit" class="">
                      <div
                        class="absolute right-3 top-2.5 h-5 w-5 text-gray-400"
                      >
                        <img src="@/assets/search_icon1.svg" alt="" srcset="" />
                      </div>
                    </button>
                  </form>
                </div>

                <div class="mt-5">
                  <div
                    v-if="totalgrouplist.length > 0"
                    class="overflow-y-auto lg:h-[calc(100vh-350px)]"
                  >
                    <div
                      v-for="group in this.totalgrouplist"
                      :key="group"
                      class=""
                    >
                      <div
                        v-if="group.id"
                        @click="setActiveGroup(group)"
                        class="flex items-center border-b py-3 gap-1 justify-center px-10 mb-0 cursor-pointer hover:bg-gray-200"
                        :class="[
                          'cursor-pointer',
                          activeStudentUUID === group.id
                            ? 'bg-gray-200'
                            : 'bg-white',
                        ]"
                      >
                        <div class="w-[11%]">
                          <p
                            class="border-1 rounded-full w-7 h-7 border-gray-300 flex items-center justify-center text-white font-bold mx-auto"
                            :style="{
                              backgroundColor: getDynamicColor(group.title),
                            }"
                          >
                            {{ group.title.charAt(0).toUpperCase() }}
                          </p>
                        </div>

                        <p
                          class="text-base lg:text-[16px] text-[#333333] w-full px-2"
                        >
                          <span class="capitalize">{{
                            group.title || "NA"
                          }}</span>
                        </p>
                      </div>
                    </div>
                  </div>
                  <div v-else class="flex justify-center">No Group</div>
                </div>
              </div>

              <!-- group list end -->

              <!-- group create start -->
              <div v-if="groupnewcreate" class="p-5 flex flex-col gap-6">
                <div class="">
                  <img
                    src="@/assets/leftarrow.svg"
                    alt=""
                    srcset=""
                    class="cursor-pointer"
                    @click="
                      this.groupnewcreate = false;
                      this.grouplist = true;
                    "
                  />
                </div>
                <form
                  action=""
                  @submit.prevent="groupform"
                  class="flex flex-col gap-6"
                >
                  <div>
                    <input
                      type="text"
                      v-model="grouptitle"
                      name=""
                      id=""
                      class="border-b border-gray-400 w-full p-3 outline-none"
                      placeholder="Group Name"
                    />
                  </div>

                  <div>
                    <textarea
                      name=""
                      id=""
                      v-model="description"
                      cols="30"
                      rows="5"
                      placeholder="Group Description "
                      class="border border-gray-400 w-full p-3 outline-none bg-[#F6F6F6]"
                    ></textarea>
                  </div>

                  <div class="flex justify-center">
                    <button
                      class="bg-blues text-white text-lg py-2 px-10 rounded-3xl"
                    >
                      Create Group
                    </button>
                  </div>

                  <div
                    v-if="createmessages"
                    class="flex justify-center text-sm text-green-400 font-bold"
                  >
                    {{ createmessages }}
                  </div>
                </form>
              </div>
            </div>
            <!-- left side end -->
            <!-- Right side start -->
            <div
              v-if="selectedgroup"
              class="bg-[#F0F5F9] h-full w-full overflow-hidden lg:w-[75%] rounded-3xl relative"
              :style="{
                backgroundImage: `url(${require('@/assets/chat/new_bg.png')})`,
              }"
              :class="
                isFullScreenContact ? 'w-full' : ' lg:w-[70%] 2xl:w-[75%]'
              "
            >
              <div
                :class="[
                  'transition-all duration-300 relative h-full',
                  showContactInfo && !isFullScreenContact
                    ? 'w-full  md:w-[calc(100%-350px)]'
                    : 'w-full ',
                ]"
                :style="{
                  backgroundImage: `url(${require('@/assets/chat/new_bg.png')})`,
                }"
              >
               <div
                  class="flex justify-end pr-4"
                  @click="
                    selectedgroup = false;
                    studentmessage = true;
                    defaultimg=true;
                  "
                >
                  <p
                    class="text-blues rounded-lg text-sm font-semibold underline cursor-pointer"
                  >
                    Back
                  </p>
                </div>
                <div
                  class="flex flex-col h-full  rounded-3xl relative"
                >
                  <div
                    class="absolute w-full left-0 right-0 cursor-pointer"
                    @click="showContactInfo = true;  this.groupstudentlist(selectedgroup.id);"
                  >
                    <div
                      class="bg-[#FFFFFF] rounded-2xl m-4 py-2 px-3 flex justify-center gap-2 items-center"
                    >
                      <div class="">
                        <p
                          class="border-1 rounded-full w-7 h-7 border-gray-300 flex items-center justify-center text-white font-bold mx-auto"
                          :style="{
                            backgroundColor: getDynamicColor(
                              this.selectedgroup.title
                            ),
                          }"
                        >
                          {{ this.selectedgroup.title.charAt(0).toUpperCase() }}
                        </p>
                      </div>
                      <p class="text-center text-primary font-semibold">
                        {{ this.selectedgroup.title || "NA" }}
                      </p>
                    </div>
                  </div>

                  <div class="h-full w-full px-3 pt-14 pb-16">
                    <div class="p-4 h-full overflow-y-auto" id="chatContainer">
                      <div
                        v-for="(message, index) in totalmessage"
                        :key="index"
                        class="my-4 flex flex-col gap-1"
                      >
                        <template v-if="shouldShowDateLabel(index)">
                          <div
                            class="text-center font-semibold text-gray-200 text-xs"
                          >
                            <button
                              class="bg-blue-300 text-white py-1 px-2 rounded-md"
                            >
                              {{ formatDateLabel(message.created_at) }}
                            </button>
                          </div>
                        </template>
                        <div
                          v-if="message.member_email"
                          class="flex"
                          :class="[
                            'my-4 flex gap-2 w-full',
                            message.member_email === this.studentdata.email
                              ? 'justify-end'
                              : 'justify-start',
                          ]"
                        >
                          <div class="flex gap-2 max-w-[350px]">
                            <div>
                              <div
                                v-if="message.member_profile_image"
                                class="w-8 h-10"
                              >
                                <img
                                  :src="message.member_profile_image"
                                  alt=""
                                  srcset=""
                                  class="rounded-full w-7 h-7 mx-auto"
                                />
                              </div>
                              <img
                                v-else
                                src="@/assets/newd/image.png"
                                alt=""
                                srcset=""
                                class="w-7 h-7 object-contain"
                              />
                            </div>
                            <div
                              class="flex flex-col gap-2 max-w-[275px]"
                              :class="[
                                !message.message && message.file_name
                                  ? message.member_email ===
                                   this.studentdata.email
                                    ? 'bg-[#E8F6FF] px-2 py-2 rounded-xl text-gray-900'
                                    : 'bg-gray-200 px-2 py-2 rounded-xl text-gray-900'
                                  : message.member_email ===
                                   this.studentdata.email
                                  ? 'bg-[#E8F6FF] text-gray-900 rounded-xl px-4 py-2 shadow-md break-words rounded-br-sm' // Text (or text + file) from self
                                  : 'bg-gray-200 text-gray-900 rounded-xl px-4 py-2 shadow-md break-words rounded-bl-sm', // Text (or text + file) from others
                              ]"
                            >
                              <div class="flex justify-between items-center">
                                <h1
                                  class="text-sm font-bold text-[#0085DB] mr-5"
                                >
                                  <span v-if="message.member_display_name">
                                    {{ message.member_display_name }}
                                  </span>
                                  <span v-else>Na</span>
                                </h1>
                                <p class="text-xs text-gray-500">
                                  {{ formatDateTime(message.created_at) }}
                                </p>
                              </div>

                              <div class="text-xs text-wrap w-full relative">
                                <div
                                  v-if="message.file_name"
                                  class="relative group w-fit"
                                >
                                  <div
                                    class="relative inline-block w-fit mt-2 group"
                                  >
                                    <!-- 🖼️ Image Preview -->
                                    <img
                                      v-if="
                                        /\.(jpe?g|png|gif|webp|bmp)$/i.test(
                                          message.file_name
                                        )
                                      "
                                      :src="message.file_name"
                                      class="rounded w-[235px] shadow cursor-pointer"
                                      alt="Image"
                                    />

                                    <!-- 📽️ Video Preview -->

                                    <video
                                      v-else-if="
                                        /\.(mp4|webm|ogg)$/i.test(
                                          message.file_name
                                        )
                                      "
                                      :src="message.file_name"
                                      controls
                                      class="rounded w-60 shadow"
                                    ></video>

                                    <div
                                      v-else
                                      class="p-2 rounded w-60 break-words text-sm text-blue-700 underline"
                                    >
                                      📄
                                      {{
                                        message.filename ||
                                        getFileName(message.file_name)
                                      }}
                                    </div>

                                    <button
                                      @click="toggleDropdown(index)"
                                      class="absolute top-1 right-1 p-1 rounded-full text-white bg-black/50 2xl:bg-transparent 2xl:text-[#4f3f3fc3] 2xl:hidden 2xl:group-hover:block"
                                      title="Options"
                                    >
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        class="w-4 h-4"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        stroke="currentColor"
                                      >
                                        <path
                                          stroke-linecap="round"
                                          stroke-linejoin="round"
                                          stroke-width="2"
                                          d="M19 9l-7 7-7-7"
                                        />
                                      </svg>
                                    </button>

                                    <div
                                      v-if="dropdownIndex === index"
                                      class="absolute top-8 right-1 bg-white border rounded shadow text-xs z-50"
                                    >
                                      <button
                                        @click="downloadFile(message)"
                                        class="px-4 py-2 hover:bg-gray-100 w-full text-left"
                                      >
                                        ⬇️ Download
                                      </button>
                                    </div>
                                  </div>
                                </div>

                                <div>
                                  <span v-if="message.message">{{
                                    message.message
                                  }}</span>
                                  <!-- <span v-else>Na</span> -->
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                       <!-- Dummy loading preview when loading a file -->
                      <div
                        v-if="sendingFileUrl"
                        class="my-4 flex gap-2 w-full justify-end"
                      >
                        <div
                          class="flex flex-col items-center justify-center p-4 rounded-lg bg-black/40 shadow-xl w-[230px] h-[100px]"
                        >
                          <img
                            src="@/assets/loading.gif"
                            alt="loading"
                            class="w-6 h-6 object-contain"
                          />
                          <p class="mt-2 text-white font-medium text-xs">
                            Loading…
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="absolute bottom-2 w-full left-0 right-0">
                    <div
                      class="bg-[#FFFFFF] rounded-2xl m-4 flex items-center justify-between py-2 px-3 gap-3"
                    >
                      <!-- Plus Button -->

                      <div class="relative">
                        <div
                          v-if="showIcons"
                            @click.stop
                          class="absolute bottom-12 left-0 flex flex-col items-center gap-3 transition-all duration-300 z-10"
                        >
                          <!-- Document Icon -->
                          <div class="relative group">
                            <button
                              @click="triggerInput('document')"
                              class="w-8 h-8 bg-blue-500 text-white rounded-full flex items-center justify-center shadow hover:bg-blue-600"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                class="w-4 h-4"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  d="M7 2h8l5 5v13a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2z"
                                />
                                <path d="M14 2v6h6" />
                              </svg>
                            </button>
                            <span
                              class="absolute left-full top-1/2 ml-2 -translate-y-1/2 bg-gray-800 text-white text-xs px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition"
                            >
                              Document
                            </span>
                          </div>

                          <!-- Image Icon -->
                          <div class="relative group">
                            <button
                              @click="triggerInput('image')"
                              class="w-8 h-8 bg-blue-500 text-white rounded-full flex items-center justify-center shadow hover:bg-blue-600"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                class="w-4 h-4"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                viewBox="0 0 24 24"
                              >
                                <rect
                                  x="3"
                                  y="3"
                                  width="18"
                                  height="18"
                                  rx="2"
                                />
                                <circle cx="8" cy="8" r="1.5" />
                                <path d="M21 15l-5-5L5 21" />
                              </svg>
                            </button>
                            <span
                              class="absolute left-full top-1/2 ml-2 -translate-y-1/2 bg-gray-800 text-white text-xs px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition"
                            >
                              Image
                            </span>
                          </div>

                          <!-- Video Icon -->
                          <div class="relative group">
                            <button
                              @click="triggerInput('video')"
                              class="w-8 h-8 bg-blue-500 text-white rounded-full flex items-center justify-center shadow hover:bg-blue-600"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                class="w-4 h-4"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                                viewBox="0 0 24 24"
                              >
                                <rect
                                  x="3"
                                  y="5"
                                  width="15"
                                  height="14"
                                  rx="2"
                                />
                                <path d="M21 7l-5 4v2l5 4V7z" />
                              </svg>
                            </button>
                            <span
                              class="absolute left-full top-1/2 ml-2 -translate-y-1/2 bg-gray-800 text-white text-xs px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition"
                            >
                              Video
                            </span>
                          </div>

                          <input
                            ref="document"
                            type="file"
                            accept=".pdf,.doc,.docx"
                            class="hidden"
                            @change="handleFile('document', $event)"
                          />
                          <input
                            ref="image"
                            type="file"
                            accept="image/*"
                            class="hidden"
                            @change="handleFile('image', $event)"
                          />
                          <input
                            ref="video"
                            type="file"
                            accept="video/*"
                            class="hidden"
                            @change="handleFile('video', $event)"
                          />
                        </div>

                        <!-- Plus Button -->
                        <button
                          @click.stop="toggleIcons"
                          class="w-8 h-8 text-white rounded-full flex items-center justify-center hover:bg-[#E8F6FF]"
                          title="Add"
                        >
                          <div v-if="!showIcons">
                            <img src="@/assets/chat/plus.svg" alt="" />
                          </div>
                          <div
                            v-else
                            class="text-[#34A9F1] bg-[#E8F6FF] rounded-full p-1"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              class="h-6 w-6"
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                            >
                              <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="M6 18L18 6M6 6l12 12"
                              />
                            </svg>
                          </div>
                        </button>
                      </div>

                      <!-- Input + Preview -->
                      <div class="flex flex-col w-full gap-2">
                        <!-- File Preview -->
                        <div
                          v-if="fileData.name"
                          class="w-full px-4 py-2 bg-gray-100 rounded-xl relative mb-1"
                        >
                          <div class="flex justify-between items-start">
                            <div>
                              <p class="text-xs font-semibold mb-1">Preview:</p>

                              <template v-if="fileData.type === 'image'">
                                <img
                                  :src="fileData.url"
                                  alt="Preview"
                                  class="w-40 rounded shadow"
                                />
                              </template>
                              <template v-else-if="fileData.type === 'video'">
                                <video
                                  :src="fileData.url"
                                  controls
                                  class="w-60 rounded shadow"
                                />
                              </template>
                              <template v-else>
                                <p class="text-xs text-gray-700">
                                  {{ fileData.name }}
                                </p>
                              </template>
                            </div>
                            <button
                              @click="clearPreview"
                              class="text-red-500 hover:text-red-700 text-sm"
                            >
                              ✕
                            </button>
                          </div>
                        </div>

                        <!-- Text Input -->
                        <input
                          v-model="messageVal"
                          @keyup.enter="newsendmsg(this.selectedgroup)"
                          type="text"
                          class="w-full border-none outline-none text-sm bg-transparent text-gray-800"
                          placeholder="Type your text here..."
                        />
                      </div>
                      <button
                        @click="newsendmsg(this.selectedgroup)"
                        class="w-[40px] h-[40px] rounded-full flex items-center justify-center"
                      >
                        <img src="@/assets/chat/right.svg" alt="" />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
               <transition name="slide">
                <div
                  v-if="showContactInfo"
                  class="absolute top-0 right-0 h-full w-full bg-[#f0f0f0]  text-white rounded-l-3xl z-40 shadow-lg"
                  :class="
                    isFullScreenContact ? 'w-full' : 'w-full 2xl:w-[350px]'
                  "
                   :style="{
                  backgroundImage: `url(${require('@/assets/chat/Whats.jpeg')})`,
                }"
                >
                  <div
                    class="flex justify-between items-center p-4 border-b border-white/10"
                  >
                    <h2 class="text-lg font-semibold">Contact Info</h2>
                    <button
                      @click="showContactInfo = false"
                      class="text-white text-2xl"
                    >
                      &times;
                    </button>
                  </div>

                  <div class="">
                    <div class="p-4 text-center mb-4">
                      <img
                        v-if="selectedgroup.member_profile_image"
                        :src="selectedgroup.member_profile_image"
                        class="w-20 h-20 object-cover rounded-full mx-auto"
                        alt="Profile"
                      />
                      <img
                        v-else
                        src="@/assets/newd/image.png"
                        class="w-20 h-20 object-cover rounded-full mx-auto"
                        alt="Default"
                      />
                      <h3 class="mt-2 font-semibold text-lg">
                        {{ selectedgroup.title }}
                      </h3>
                      <p class="text-sm text-gray-400">
                        Hey there! I am using Group chat.
                      </p>
                    </div>

                    <!-- Media/docs preview -->
                    <div class="hidden">
                      <h4 class="font-semibold text-sm text-gray-400 mb-2">
                        Media, Docs
                      </h4>
                      <div class="grid grid-cols-3 gap-2">
                        <div
                          v-for="n in 3"
                          :key="n"
                          class="w-full h-20 bg-white/10 rounded"
                        ></div>
                      </div>
                    </div>
                    <div class="px-4 py-2 text-gray-300 flex items-center">{{studentgrouplist.length}} Members only </div>
                    <div
                      class="w-full max-w-md mx-auto  text-white rounded-lg shadow-lg overflow-hidden"
                    >
                      <div
                        class="divide-y divide-[#2a3942] h-[calc(100vh-467px)] overflow-y-auto py-2 rounded-b-3xl"
                      >
                        <div
                          v-for="(student, index) in studentgrouplist"
                          :key="index"
                          class="flex items-center gap-3 px-4 py-3 hover:bg-[#202c33] cursor-pointer"
                        >
                          <div
                            class="w-9 h-9 rounded-full flex items-center justify-center text-white font-bold"
                          >
                            <div v-if="student.profile_image">
                              <img
                                :src="student.profile_image"
                                alt=""
                                class="w-9 h-9 rounded-full border-2 border-white"
                              />
                            </div>
                            <div v-else>
                              <img
                                src="@/assets/new/image.png"
                                alt=""
                                class="w-9 h-9 rounded-full border-2 border-white"
                              />
                            </div>
                          </div>
                          <div class="flex-1">
                            <div class="font-medium text-sm">
                              {{ student.display_name }}
                            </div>
                            <!-- <div class="text-sm text-gray-400 line-clamp-1">
                              {{ student.status }}
                            </div> -->
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </transition>
            </div>
            <!-- Right side end -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Student/Header.vue";
import SideBar from "@/components/Student_preview/SideBar.vue";

import axios from "axios";
import { mapGetters } from "vuex";

export default {
  components: {
    Header,
    SideBar,
  },
  data() {
    return {
      messageVal: null,
      totalmessage: [],
      totalgrouplist: [],
      activeStudentUUID: null,
      selectedgroup: null,
      ChatpopUp: false,
      grouplist: true,
      groupnewcreate: false,
      description: "",
      grouptitle: "",
      createmessages: "",
      search_title: "",
      socket: null,
      activeGroup: null,
      showIcons: false,
      fileData: {
        type: "",
        name: "",
        url: "",
        raw: null,
      },
      dropdownIndex: null,
      showContactInfo: false,
      isFullScreenContact: false,
      studentmessage: true,
      sendingFileUrl:"",
       studentgrouplist: [],
      defaultimg: true,

    };
  },

  created() {
    this.getgrouplist();
  },

  props: ["course_id"],

  computed: {
     ...mapGetters("student", [
      "studentdata"]),
  },

  mounted() {
     document.addEventListener("click", this.handleClickOutside);
    setTimeout(() => {
      let chatContainer = document.getElementById("chatContainer");

      if (chatContainer) {
        console.log("Height::::=", chatContainer.offsetHeight);
        chatContainer.scrollTo({
          top: chatContainer.scrollHeight + 300,
          behavior: "smooth",
        });
      }
    }, 200);
  },
   beforeUnmount() {
    document.removeEventListener("click", this.handleClickOutside);
  },

  methods: {
    triggerInput(type) {
      this.$refs[type].click();
    },
    handleFile(type, event) {
      const file = event.target.files[0];
      if (!file) return;

      this.fileData.name = file.name;
      this.fileData.type = type;
      this.fileData.raw = file;

      if (type === "image" || type === "video") {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.fileData.url = e.target.result;
        };
        reader.readAsDataURL(file);
      } else {
        this.fileData.url = "";
      }

      this.toggleIcons();
    },
    clearPreview() {
      this.fileData = { type: "", name: "", url: "", raw: null };
      ["document", "image", "video"].forEach((type) => {
        if (this.$refs[type]) this.$refs[type].value = "";
      });
    },
    toggleIcons() {
      this.showIcons = !this.showIcons;
    },
     handleClickOutside(event) {
      if (!event.target.closest(".dropdown-container")) {
        this.showIcons = false;
      }
    },
    toggleDropdown(index) {
      this.dropdownIndex = this.dropdownIndex === index ? null : index;
    },
    downloadFile(message) {
      const link = document.createElement("a");
      link.href = message.file_name;
      link.download = message.filename || this.getFileName(message.file_name);
      link.target = "_blank";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      this.dropdownIndex = null;
    },
    getFileName(filePath) {
      return filePath.split("/").pop();
    },
    formatDateTime(isoString) {
      const date = new Date(isoString);

      const daysOfWeek = ["Sun", "Mon", "Tues", "Wed", "Thurs", "Fri", "Sat"];
      const dayName = daysOfWeek[date.getDay()];

      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();

      let hours = date.getHours();
      const minutes = String(date.getMinutes()).padStart(2, "0");
      const ampm = hours >= 12 ? "PM" : "AM";

      hours = hours % 12;
      hours = hours ? hours : 12;

      return `${dayName} ${hours}:${minutes} ${ampm}`;
      // Output: Sunday 09/04/2025 5:20 PM
    },
    formatDateLabel(isoString) {
      const date = new Date(isoString);
      const now = new Date();

      const isToday = date.toDateString() === now.toDateString();

      const yesterday = new Date();
      yesterday.setDate(now.getDate() - 1);
      const isYesterday = date.toDateString() === yesterday.toDateString();

      if (isToday) return "Today";
      if (isYesterday) return "Yesterday";

      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();

      return `${day}/${month}/${year}`;
    },

    shouldShowDateLabel(index) {
      if (index === 0) return true;

      const current = this.formatDateLabel(this.totalmessage[index].created_at);
      const previous = this.formatDateLabel(
        this.totalmessage[index - 1].created_at
      );

      return current !== previous;
    },

    getDynamicColor(name) {
      let hash = 0;

      for (let i = 0; i < name.length; i++) {
        hash = name.charCodeAt(i) + ((hash << 5) - hash);
      }
      const color = `#${("00000" + (hash & 0xffffff).toString(16)).slice(-6)}`;

      return color;
    },
   scrollToBottomChat() {
      setTimeout(() => {
        let chatContainer = document.getElementById("chatContainer");
        if (chatContainer) {
          console.log("Height::::=", chatContainer.offsetHeight);

          chatContainer.scrollTo({
            top: chatContainer.scrollHeight + 300,
            behavior: "smooth",
          });
        }
      }, 200);
    },
      async groupstudentlist(id) {
      console.log("iddddd::", id);
      await axios
        .get(
          `${process.env.VUE_APP_API}/forum-students/get/${id}/?Key=${this.studentdata.studentToken}`
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.studentgrouplist = response.data.data;
            console.log(" this.studentgrouplist", this.studentgrouplist);
          }
        });
    },

    groupcreate() {
      this.grouplist = false;
      this.groupnewcreate = true;
    },
    groupform() {
      let formdata = {
        title: this.grouptitle,
        description: this.description,
        course: this.course_id,
        is_form: true,
        created_by: this.studentdata.studentId,
      };

      axios
        .post(
          `${process.env.VUE_APP_API}/course-forum-create/?Key=${this.studentdata.studentToken}`,
          formdata
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.createmessages = response.data.message;
            setTimeout(() => {
              this.createmessages = "";
              this.groupnewcreate = false;
              this.grouplist = true;
              this.getgrouplist();
              this.grouptitle = "";
              this.description = "";
            }, 1200);
          }
        })
        .finally(() => {});
    },
    async getgrouplist() {
      await axios
        .get(
          `${process.env.VUE_APP_API}/course-forum-get/?Key=${this.studentdata.studentToken}&course__id=${this.course_id}`
        )
        .then((response) => {
          if (response.data.data.status == 200) {
            this.totalgrouplist = response.data.data.data;
            if (this.totalgrouplist.length > 0) {
              this.setActiveGroup(this.totalgrouplist[0]);
            }
            console.log(" this.totalgrouplist", this.totalgrouplist);
          }
        });
    },
    async searchUserValue() {
      await axios
        .get(
          `${process.env.VUE_APP_API}/course-forum-get/?search=${this.search_title}&Key=${this.studentdata.studentToken}&course__id=${this.course_id}`
        )
        .then((response) => {
          if (response.data.data.status == 200) {
            this.totalgrouplist = response.data.data.data;
            console.log(" this.totalgrouplist", this.totalgrouplist);
          }
        });
    },
    async setActiveGroup(group) {
      this.defaultimg = false;
      this.activeStudentUUID = group.id;
      this.selectedgroup = group;
      this.studentmessage = false;
      this.totalmessage = [];
      this.groupstudentlist(group.id)
      await this.getmessage(group);
      this.websocket(group);
    },

    async getmessage(group) {
      try {
        const response = await axios.get(
          `${process.env.VUE_APP_API}/group-room-get/${group.id}/?Key=${this.studentdata.studentToken}`
        );

        if (response.data.status === 200) {
          this.totalmessage = response.data.data || [];
          this.scrollToBottomChat();
        } else {
          console.error("Unexpected response:", response.data);
        }
      } catch (error) {
        console.error("Failed to fetch messages", error);
      }
    },
    websocket(group) {
      if (this.socket) {
        this.socket.close();
      }

      const socket = new WebSocket(
        `${process.env.VUE_APP_SOCKET_URL}/ws/chat/${group.id}/?Key=${this.studentdata.studentToken}`
      );
      this.socket = socket;
      socket.onopen = () => {
        console.log(`Connected to socket chat ${group.id}`);
      };

      socket.onmessage = (event) => {
        try {
          const msg = JSON.parse(event.data);
           if (msg.file_name) {
            this.sendingFileUrl = "";
          }
          if (msg.file?.startsWith("/media/")) {
            msg.file = `${process.env.VUE_APP_API}${msg.file}`;
          }
          console.log("event.data", event.data);
          this.totalmessage.push(msg);
          this.scrollToBottomChat();
        } catch (err) {
          console.error("Error parsing incoming message:", err);
        }
      };

      socket.onclose = () => {
        console.log("Private chat WebSocket closed.");
      };

      socket.onerror = (error) => {
        console.error("Private chat WebSocket error:", error);
      };
    },

    newsendmsg() {
      const text = this.messageVal?.trim();

      if (!text && !this.fileData?.name) {
        console.warn("Empty message and no file selected.");
        return;
      }

      const message = {
        username: this.studentdata.email,
        message: text || "",
      };

      if (this.fileData?.name) {
        message.file_name = this.fileData.name;

        if (this.fileData.url?.startsWith("data:")) {
          message.file_data = this.fileData.url.split(",")[1];
           this.sendingFileUrl = this.fileData.url.split(",")[1];
          this.sendWebSocketMessage(message);
        } else {
          const reader = new FileReader();
          reader.onload = (e) => {
            const base64 = e.target.result;
            message.file_data = base64.split(",")[1];
             this.sendingFileUrl = base64.split(",")[1];
            this.sendWebSocketMessage(message);
          };
          reader.onerror = (err) => {
            console.error("File reading error", err);
          };
          reader.readAsDataURL(this.fileData.raw);
        }

        return;
      }

      this.sendWebSocketMessage(message);
    },

    sendWebSocketMessage(message) {
      if (this.socket && this.socket.readyState === WebSocket.OPEN) {
        const payload = JSON.stringify(message);
        this.socket.send(payload);
         this.scrollToBottomChat();
        this.messageVal = "";
        this.clearPreview();
      } else {
        console.warn("WebSocket is not connected.");
      }
    },
  },
};
</script>

<style scoped>
.heightfix {
  height: calc(100vh - 390px) !important;
}
</style>
